import { useContext } from 'react'

import { ConsultationContext, ConsultationContextProps } from '@/contexts/consultation'
import { useFormErrors } from '@/hooks/useFormErrors'

interface UseQuestionProps {
  question: ConsultationContextProps['currentQuestion']
  updateQuestion: (text: string) => void
  resetQuestion: () => void
  attachments: ConsultationContextProps['attachments']
  setAttachments: ConsultationContextProps['setAttachments']
}

export const useQuestion = (): UseQuestionProps => {
  const { currentQuestion: question, setCurrentQuestion: setQuestion, attachments, setAttachments } = useContext(ConsultationContext)
  const { clearFormError } = useFormErrors()

  const updateQuestion = (text: string) => {
    setQuestion((prev) => {
      return {
        ...prev,
        question: text
      }
    })
  }

  const resetQuestion = () => {
    setQuestion({
      question: '',
      attachments: []
    })
    setAttachments([])
    clearFormError('question')
  }

  return {
    question,
    updateQuestion,
    resetQuestion,
    attachments,
    setAttachments
  }
}
